<template>
    <div class="settlement">
        <div class="box" v-if="isReload==false && product_data.length!==0">
            <!-- 订单信息 -->
            <ul class="order_info">
                <li>
                    <h3>核对订单信息</h3>
                </li>
                <li >
                    <h3>收货人信息</h3>
                    <transition-group tag="div" name="silder" class="address_box">
<!--                        <button v-if="my_address.length<20" class="add_address" :key="20" >-->
<!--                            <i class="iconfont icon-jiahao" @click="create_address"></i>-->
<!--                            <i>添加新地址</i>-->
<!--                        </button>-->
                        <button class="add_address" :key="20" >
                            <i class="iconfont icon-jiahao" @click="create_address"></i>
                            <i>添加新地址</i>
                        </button>
                        <div  class="address" :class="{showbg:index==0}"  v-for="(item,index) in my_address.slice(0,last_index)" :key="'A'+index" @click="selectAddress(index)" ref="active">
                            <p ><span>{{item.receiver}}</span><span>{{item.phone}}</span></p>
                            <p ><span>{{item.province}}</span><span>{{item.city}}</span><span>{{item.area}}</span><span>{{item.address_detail}}</span></p>
                            <p v-show="index==0">[ <span>默认地址</span> ]</p>
                        </div>
                    </transition-group>
                    <div class="look_more"><i class="iconfont icon-xiala" @click="look_more(1)" v-if="last_index===3"> 查看更多</i><i class="iconfont icon-xiangshang" v-else @click="look_more(2)"> 向上收起</i></div>
                </li>
                <li>
                    <!-- 商品 -->
                    <ul class="goods_operation">
                        <li>
                            <h3>商品确认</h3>
                            <div @click="$router.go(-1)">返回修改 <i class="iconfont icon-youkuohao" style="font-size:12px;">&#xe684;</i></div>
                        </li>
                        <li >
                            <span >
                            </span>
                            <span >商品名称</span>
                            <span >单价</span>
                            <span >数量</span>
                            <span >库存</span>
                            <span >小计（元）</span>
                        </li>
                        <li v-for="(item,index) in product_data" :key="'B'+index">
                            <span >
                                <el-image
                                    fit="cover"
                                    style="width:120px;min-width:120px;height:120px;"
                                    :src="item.product_img_url"
                                >
                                    <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                        <div class="el_image">
                                            <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>
                                        </div>
                                    </div>
                                    <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                        <div class="el_image">
                                            <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                                        </div>
                                    </div>
                                </el-image>
                            </span>
                            <span>{{item.product_name}}</span>
                            <span>
                                <p>{{item.unit_price}}</p>
                                <p>{{item.discount_price}}</p>
                            </span>
                            <span>{{item.product_qty}}</span>
                            <span>{{item.product_store_qty}}</span>
                            <span>{{item.subtotal_price}}</span>
                        </li>
                    </ul>
                </li>
                <li>
                    <div class="order_time" v-if="isReserve == 1">
                        <span>{{'生产周期：'}}</span>
                        <span>{{production_day_num + '天'}}</span>                     
                    </div>
                    <div class="order_time" v-if="isReserve == 1">
                        <span v-if="isReserve == 1">预计发货日期：</span>
                        <el-date-picker                           
                            v-model="production_day"
                            type="date"
                            placeholder="选择日期"
                            value-format="timestamp"
                            disabled
                            style="width: 250px;"
                            >
                        </el-date-picker>
                    </div>
                    <div class="order_time" v-if="isReserve == 1">
                        <span ><i style="color:red">*</i>期望发货日期：</span>
                        <el-date-picker
                            v-model="hope_delivery_date"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            style="width: 250px;"
                            >
                        </el-date-picker>
                    </div>
                                        <div class="order_time">
                        <!-- 备注 -->
                        <span> <i style="color:red">*</i> 订单负责人：</span>
    <!--                    <el-input type="text"   placeholder="请选择订单负责人" v-model="formData.textarea" ></el-input>-->
    <!--                    <el-button>点击选择负责人</el-button>-->
                        <el-autocomplete
                                class="inline-input"
                                v-model="state1"
                                :fetch-suggestions="querySearch"
                                placeholder="点击选择负责人"
                                @select="handleSelect"
                                style="width: 250px;"
                        ></el-autocomplete>
                    </div>
                </li>
                <li>
                    <!-- 备注 -->
                    <span>备&nbsp;&nbsp;注：</span>
                    <el-input type="textarea" maxlength="200" resize="none"  placeholder="备注信息(200字内)" v-model="formData.textarea" ></el-input>
                </li>
                <li>
                    <ul>
                        <li>已选择&nbsp;{{data.product_count}}&nbsp;件，合计(不含运费)：<label>￥<i>{{data.product_sum_price}}</i></label></li>
                        <li>运&nbsp;&nbsp;费：<label>￥<i>{{productFreight}}</i></label></li>
                        <li>经销商折扣：<label>￥<i>{{0-data.youhui_price}}</i></label></li>
                        <li v-if="isReserve == 1">预订折扣：<label>￥<i>{{0-data.reserve_discount_price.toFixed(2)}}</i></label></li>
                    </ul>
                    <ul>
                        <li>实际付款：<label class="label">￥<i>{{(Number(data.product_pay_price) + Number(productFreight))}}</i></label></li>
                        <li>收&nbsp;&nbsp;件&nbsp;&nbsp;人：<label >{{address_info.receiver}}</label></li>
                        <li>收货地址：<label >{{address_info.province}}&nbsp;&nbsp;{{address_info.city}}&nbsp;&nbsp;{{address_info.area}}&nbsp;&nbsp;{{address_info.address_detail}}</label></li>
                        <li><div @click="submit_order">提交订单</div></li>
                    </ul>
                </li>
            </ul>
            <!-- 添加地址模态框 -->
            <el-dialog
                title="新建收货地址"
                :visible.sync="dialogVisible"
                :before-close="handleClose"
                width="571px">
                <ul class="modal_content">
                    <li>
                        <label ><i>*</i>收 货 人：</label>
                        <el-input placeholder="请输入收货人姓名" v-model="formData.input.input1" clearable aria-required=""></el-input>
                        <b ref="input1"></b>
                    </li>
                    <li>
                        <label ><i>*</i>手 机 号：</label>
                        <el-input placeholder="请输入手机号" v-model="formData.input.input2" clearable></el-input>
                        <b ref="input2"></b>
                    </li>
                    <li>
                        <label ><i>*</i>收货地址：</label>
                        <!-- 省 -->
                        <el-select v-model="formData.select.select1" clearable placeholder="省/直辖市/自治区" class="area select" @change="select_province">
                            <el-option
                                v-for="(item,index) in province"
                                :key="'C'+index"
                                :label="item.region_name"
                                :value="item.region_id">
                            </el-option>
                        </el-select>
                        <!-- 市 -->
                        <el-select v-model="formData.select.select2" v-show="formData.select.select1"  clearable placeholder="城市" class=" select" @change="select_city">
                            <el-option
                                v-for="(item,index) in city"
                                :key="'D'+index"
                                :label="item.region_name"
                                :value="item.region_id">
                            </el-option>
                        </el-select>
                        <!-- 区 -->
                        <el-select v-model="formData.select.select3"  v-show="formData.select.select2" clearable placeholder="区/县" class=" select">
                            <el-option
                                v-for="(item,index) in area"
                                :key="'E'+index"
                                :label="item.region_name"
                                :value="item.region_id">
                            </el-option>
                        </el-select>
                        <b ref="select"></b>
                    </li>
                    <li>
                        <label ><i>*</i>详细地址：</label>
                        <el-input placeholder="请输入详细地址" v-model="formData.input.input3" clearable></el-input>
                        <b ref="input3"></b>
                    </li>
                    <li>
                        <el-checkbox v-model="formData.checked">设为默认地址</el-checkbox>
                    </li>
                </ul>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="saveAddress">保存</el-button>
                </span>
            </el-dialog>
        </div>

        <!-- 数据加载 -->
        <div v-if="isReload"  style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <div v-loading="true"></div>
            <div style="color:#409eff;font-size:14px;margin:100px 0 0 -14px;">数据加载中</div>
        </div>
        <!-- 无数据 -->
        <div v-if="isReload==false && product_data.length==0"
            style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <el-image
                fit="cover"
                style="width:600px;height:600px;"
                :src="src.src_null"
            >
                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                    <div class="el_image">
                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                    </div>
                </div>
                <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                    <div class="el_image">
                        <el-image  fit="cover" :src="src.src_err"  style="width:100px;height:100px;"></el-image>
                    </div>
                </div>
            </el-image>
        </div>
    </div>
</template>
<script>
import src_err from '@/assets/img/err.png'
import src_null from '@/assets/img/null.png'
let moment = require("moment");
export default {
    name:'settlement',
    data(){
        return {
            production_day: null,
            production_day_num: null,
            hope_delivery_date: null,
            isReserve: 0,
            src:{
                src_err,
                src_null
            },
            dialogVisible: false,
            // 是否加载
            isReload:true,
            // 添加地址
            formData:{
                input:{
                    input1:'',
                    input2:'',
                    input3:'',
                },
                textarea:'',
                checked:false,
                select:{
                    select1:'',
                    select2:'',
                    select3:'',
                }
            },
            // 页面数据
            data:{},
            // 选中的地址
            address_info:{},
            // 收货地址
            my_address:[],
            // 商品
            product_data:[],
            // 省
            province:[],
            // 市
            city:[],
            // 区
            area:[],
            last_index:3,
          state1:'',
          uHash:'',
          productFreight: 0
        }
    },
    watch:{
        'formData.select.select1':function(){
            this.formData.select.select2=''
            this.formData.select.select3=''
        },
        'formData.select.select2':function(){
            this.formData.select.select3=''
        },
    },
    computed:{
        getUserInfo(){
            return this.$store.getters.get_userInfo
        }
    },
    methods: {
        // 获取运费
        getProductFreight() {
            const options = {
                product_hash: this.$route.query.product_hash,
                qty: this.$route.query.qty,
                address_hash: this.address_info.address_hash
            }
            this.$http({
                url: 'productFreight',
                data: options
            })
                .then((res) => {
                this.productFreight = res.data
                })
                .catch((err) => {
                console.log(err);
                });
        },
      querySearch(queryString,cb){
        var restaurants = this.restaurants;
        // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(restaurants);
      },
      // createFilter(queryString) {
      //   return (restaurant) => {
      //     return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      //   };
      // },
      // loadAll() {
      //   return [
      //     { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
      //     { "value": "Hot honey 首尔炸鸡（仙霞路）", "address": "上海市长宁区淞虹路661号" },
      //     { "value": "新旺角茶餐厅", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
      //     { "value": "泷千家(天山西路店)", "address": "天山西路438号" },]
      // },

      handleSelect(item){
        console.log(item);
        this.uHash = item.uhash;
      },
        // 查看更多地址
        look_more(o){
            if(o===1){
                this.last_index=this.my_address.length
            }else if(o===2){
                this.last_index=3
            }
        },
        // 添加地址模态框关闭前的回调
        handleClose(done){
            this.clear_input()
            done();
        },
        // 选择地址
        selectAddress(o){
            if(o>=0){
                let arr=this.$refs.active
                for(let i in arr){
                    arr[i].classList.remove('showbg')
                    arr[i].classList.add('closebg')
                }
                this.$refs.active[o].classList.remove('closebg')
                this.$refs.active[o].classList.add('showbg')
                this.address_info=this.data.my_address[o]
                this.getProductFreight()
            }
        },
        // 点击添加按钮得到省
        create_address(){
            // if(this.data.my_address.length<20){
                this.dialogVisible = true
                this.getAddressAjax(1,1)
            // }else{
            //     this.$message({
            //         message: `最对可添加20个收获地址`,
            //         type: 'warning'
            //     });
            // }
        },
        // 选择省得到市
        select_province(o){
            this.getAddressAjax(2,o)
        },
        // 选择市得到区
        select_city(o){
            this.getAddressAjax(3,o)
        },
        // 获取省市区数据的ajax
        getAddressAjax(d,o){
            this.$http({
                url:'get_addressData',
                data:{
                    type:d,
                    parent_id:o
                }
            }).then((res)=>{
                if(res.code==1){
                    if(d==1){
                        this.province=res.data.region
                    }
                    if(d==2){
                        this.city=res.data.region
                    }
                    if(d==3){
                        this.area=res.data.region
                    }
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        //获取负责人
        getCustomSales(){
          this.$http({
            url:'custom_sales',
            data:{
            }
          }).then((res)=>{
            if(res.code==1){
                console.log(res.data)
              var userArr = res.data.user_list
              var userValue = []
              for (let i = 0;i<userArr.length;i++){
                var item = userArr[i]

                item.value = item.nickname+ '-'+item.username;
                userValue.push(item)
              }
              console.log(userArr)
              if (userValue.length>0){
                this.restaurants = userValue
              }else {
                this.restaurants = [{value:'无负责人,请联系销售'}];
              }

            }
          }).catch((err)=>{
            console.log(err)
          })
        },
        // 保存地址
        saveAddress(){
            let isTrue=this.form_check()
            if(isTrue===false){
                return
            }
            this.$http({
                url: 'add_address',
                data: {
                    receiver:this.formData.input.input1,
                    phone:this.formData.input.input2,
                    province:this.formData.select.select1,
                    city:this.formData.select.select2,
                    area:this.formData.select.select3,
                    address:this.formData.input.input3,
                    is_default:Number(this.formData.checked)
                },
            }).then(res=>{
                if(res.code==1){
                    this.$message({
                        message: `${res.msg}`,
                        type: 'success'
                    });
                    this.last_index+=this.last_index
                    this.getPageAjax()
                }
            }).catch(error => {
                console.log(error);
            });
            this.clear_input()
            this.dialogVisible = false
        },
        // 提交订单
        submit_order(){
            if(this.my_address.length===0){
                this.$message({
                    message: '地址为空! 请先添加收货地址',
                    type: 'warning'
                });
                return
            }
            if(this.isReserve==1&&this.hope_delivery_date==null){
                this.$message({
                    message: '请选择期望发货日期',
                    type: 'warning'
                });
                return
            }
            if(this.uHash.length===0){
                this.$message({
                    message: '请选择负责人',
                    type: 'warning'
                });
                return
            }
           
            console.log('测试')
            let arr=this.data.product_data
            let str=''
            let num=''
            for(let i in arr){
                str+=arr[i].product_hash+','
                num+=arr[i].product_qty+','
            }

            let options = {
                    address_hash:this.address_info.address_hash,
                    product_hash:str,
                    remark:this.formData.textarea,
                    qty:num,
                    custom_sale_uhash:this.uHash,
                    freight_money: this.productFreight
                }
            // 当是预购单时需要增加参数 
            if(this.isReserve == 1 ){
                options.if_reserve = 1
                options.hope_delivery_date = this.hope_delivery_date
            }
            console.log(options)
            this.$http({
                url:'new_order_submit',
                data:options
            }).then((res)=>{
                if(res.code==1){
                    this.$message({
                        message: `${res.msg}`,
                        type: 'success'
                    });
                    this.$router.push('/personal_center/my_order')
                }else{
                    this.$message({
                        message: `${res.msg}`,
                        type: 'error'
                    });
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 获取页面数据的ajax
        getPageAjax(){
            let options = {
                    product_hash:this.$route.query.product_hash,
                    qty:this.$route.query.qty,
                }
            if(this.isReserve ==1){
                options.if_reserve = 1
            }
            this.$http({
                url:'settlement',
                data:options
            }).then((res)=>{
                this.isReload=false
                if(res.code==1){
                    this.data=res.data
                    this.product_data=res.data.product_data
                    this.my_address=res.data.my_address

                    if(res.data.my_address.length!==0){
                        this.address_info=res.data.my_address[0]
                        this.getProductFreight()
                    }

                    this.production_day_num =  parseInt(res.data.production_day)
                    this.production_day = new Date().getTime() + parseInt(res.data.production_day)*24*60*60*1000
                    this.hope_delivery_date = moment(this.production_day).format('YYYY-MM-DD')
                    console.log(moment(this.production_day).format('YYYY-MM-DD'))
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 获取购物车商品数量
        getGoodsCound(){
            this.$http({
                url: 'goods_count',
                data: {}
            }).then((res)=>{
                if(res.code==1){
                    this.$store.commit({
                        type:'set_goodsCount',
                        num:res.data.cart_product_count
                    })
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // input非空判断
        form_check(){
            if(!this.formData.input.input1){
                this.$refs.input1.innerHTML="请填写收货人姓名"
                return false
            }
            if(!this.formData.input.input2){
                this.$refs.input2.innerHTML="请填写手机号"
                return false
            }
            if(!this.formData.select.select1 || !this.formData.select.select2 || !this.formData.select.select3){
                this.$refs.select.innerHTML="请填写省/市/区"
                return false
            }
            if(!this.formData.input.input3){
                this.$refs.input3.innerHTML="请填写详细收货地址"
                return false
            }
            return true
        },
        // 清空input
        clear_input(){
            this.formData.input.input1='',
            this.formData.input.input2='',
            this.formData.input.input3='',
            this.formData.select.select1='',
            this.formData.select.select2='',
            this.formData.select.select3='',
            this.formData.checked=false

            this.$refs.input1.innerHTML=''
            this.$refs.input2.innerHTML=''
            this.$refs.input3.innerHTML=''
            this.$refs.select.innerHTML=''
        },
    },
    created(){
        this.isReserve = this.$route.query.isReserve
        if(this.$route.query.product_hash){
            this.getPageAjax()
        }
        this.getGoodsCound()
      this.getCustomSales()
    },
  mounted() {
    // this.restaurants = this.loadAll();
  }
}
</script>
<style lang="scss" scoped>
.settlement{
    background:#F7F7F5;
    box-sizing:border-box;
    padding-top:110px;
}
.box{
    height:100%;
}
.order_info{
    width:1200px;
    margin:0 auto;
    padding:30px 0;
    >li{
        display:flex;
        background:white;
    }
    >li:first-child{
        align-items:center;
        justify-content: center;
        font-size:24px;
        height:70px;
        line-height:70px;
    }
    >li:nth-child(2){
        padding:70px 20px 70px;
        margin:20px 0;
        position:relative;
        flex-wrap:wrap;
        >h3{
            position:absolute;
            left:8px;
            top:0;
            padding:0 20px;
            font-size:24px;
            height:70px;
            line-height:70px;
        }
        .address_box{
            display:flex;
            flex-wrap:wrap;
            width:100%;
        }
        .look_more{
            position:absolute;
            bottom:0;
            left:0;
            width:100%;
            height:50px;
            border-top:1px solid #DDDDDD ;
            i{
                display:block;
                width:100px;
                line-height:50px;
                margin:0 auto;
                cursor:pointer;
                font-size:14px;
            }
            i:hover{
                color:#409eff;
            }
        }
    }
    >li:nth-child(4){
        margin:20px 0;
        padding:30px 40px;
        align-items: center;
        flex-direction: column;
        .order_time{
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom:10px ;
            span{
                width:200px;
                text-align: left;
            }
        }
        
    }
    >li:nth-child(5){
        margin:20px 0;
        padding:30px 40px;
        align-items: center;
        span{
            width:88px;
        }
    }
    >li:nth-child(6){
        flex-direction: column;
        >ul{
            width:100%;
            box-sizing: border-box;
            padding:20px 30px;
            >li{
                display:flex;
                justify-content: flex-end;
                padding:8px 0;
                label{
                    display:block;
                    width:200px;
                    text-align: right;
                }
                .label{
                    color:#F41200;
                    font-size:30px;
                }
            }
        }
        >ul:first-child{
            >li{
                align-items: center;
                label{
                    width:100px;
                }
            }
            >li:nth-child(3){
                label{
                    color:#F41200;
                }
            }
            >li:nth-child(4){
                label{
                    color:#F41200;
                }
            }
        }
        >ul:last-child{
            border-top:1px solid #DDDDDD ;
            padding-bottom:10px;
            >li:first-child{
                align-items: center;
            }
            >li:last-child{
                div{
                    width:160px;
                    height:50px;
                    line-height:50px;
                    text-align:center;
                    font-weight:900;
                    color:white;
                    border-radius:30px;
                    background:#F41200 ;
                    margin-top:30px;
                    cursor:pointer;
                }
            }
        }
    }
}
.address{
    box-sizing: border-box;
    width: 270px;
    min-width:270px;
    height: 155px;
    margin:9px;
    padding:15px 20px;
    font-size:12px;
    border:2px solid #CCCCCC;
    cursor:pointer;
    >p:first-child{
        display:flex;
        justify-content: space-between;
        margin-bottom:5px;
    }
    >p:nth-child(2){
        height:90px;
        overflow: hidden;
        >span{
            margin-right:6px;
            line-height:18px;
        }
    }
    >p:last-child{
        color:#45A3DC ;
    }
}
.showbg{
    background:url('../assets/img/border_image.png') no-repeat;
    border:none;
}
.closebg{
    background:none;
    border:2px solid #CCCCCC;
}
.add_address{
    border:none;
    outline:none;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 270px;
    height: 155px;
    margin:9px;
    border:2px solid #DDDDDD;
    background:white;
    i:first-child{
        width:35px;
        height:35px;
        text-align: center;
        line-height:35px;
        font-size:28px;
        color:#888;
        border-radius:50%;
        margin-bottom:10px;
        cursor: pointer;
    }
}
.goods_operation{
    width:100%;
    >li{
        display:flex;
        align-items: center;
        height:60px;
        border-bottom:2px solid #f7f7f5;
        >span{
            width:142px;
            display:flex;
            justify-content: center;
            text-align: center;
        }
        >span:nth-child(1){
            width:200px;
        }
        >span:nth-child(3){
            flex-direction: column;
        }
        >span:nth-child(4){
            flex-direction: column;
        }
        >span:nth-child(2){
            width:350px;
        }
        >span:nth-child(5){
            // width:200px;
        }
    }
    >li:nth-child(1){
        justify-content: space-between;
        height:80px;
        padding:0 40px;
        >h3{
            font-weight:500;
            font-size:24px;
        }
        >div{
            font-size:14px;
            cursor: pointer;
        }
        >div:hover{
            color:#4285f4;
        }
    }
    >li:nth-child(2)~li{
        // border:none;
        height:140px;
        >span:nth-child(1){
            display:flex;
            align-items: center;
        }
        >span:nth-child(3){
            p{
                line-height:30px;
            }
            p:first-child{
                text-decoration: line-through;
                color:#BABDBF ;
            }
        }
        >span:nth-child(4){
            p{
                line-height:30px;
            }
            p:first-child{
                text-decoration: line-through;
                color:#BABDBF ;
            }
        }
        >span:nth-child(6){
            color:#f51200;
        }
        >span:nth-child(8){
            cursor:pointer;
        }
    }
}
// 模态框
.modal_content{
    >li{
        display:flex;
        align-items: center;
        padding:15px 0;
        position:relative;
        >label{
            display:flex;
            align-items: center;
            min-width:86px;
            >i{
                padding-top:10px;
                font-size:22px;
                color:#f51200;
                margin-right:5px;
            }
        }
        >b{
            font-size:12px;
            position:absolute;
            left:100px;
            top:60px;
            color:#f51200;
        }
    }
    >li:last-child{
        padding:15px 0 0 85px;
    }
}
.silder-enter-active{
    opacity:.5;
    color:white;
    transform: scale(0);
}
.silder-enter-to{
    transition:all .5s;
    opacity:1;
    transform:scale(1);
}

</style>
<style scoped>
.order_info >>> .el-textarea__inner{
    padding:5px;
    min-height:75px!important;
}
.modal_content>li:nth-child(3) >>> .el-input{
    width:130px;
}
.modal_content>li:nth-child(3)>.area >>> .el-input{
    width:160px;
}
.modal_content>li:nth-child(3)>.select:nth-child(3){
    margin:0 12px;
}
.box >>> .el-dialog__header{
    text-align:center;
}

.box >>> .el-dialog__footer{
    text-align: center;
}
.box >>> .el-dialog__body{
    padding:20px;
}
.box >>>  .el-button{
    border-radius:20px;
    padding: 12px 40px;
}
.box >>> .el-dialog__title {
    font-size:24px;
}
.box >>> .el-icon-close:before{
    font-size:26px;
}
</style>
